import '../css/Viewpage.css';
import Popup from './Popup';
import { useEffect, useRef, useState, useLocation } from 'react';
import Filter from './Filter';
import Notification from './Notification';
import { Navigate, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import ProfileListData from '../model/response/ProfileListData';
import ProfileListRequest from '../model/request/ProfileListRequest';
import logo from '../images/logo.jpeg';
import { Oval } from "react-loader-spinner";
import user from '../images/user.png';
import shortlist from '../images/shortlist.png';
import notShortlist from '../images/nonshortlist.png';
import TopBar from './TopBar.js';
import DocumentRequest from '../model/request/Documentrequest';
import DocumentstatusResponse from '../model/response/DocumentstatusResponse';
import default_avatar from '../images/default_avatar.png';




function Interestpage() {
    const calledOnce = useRef(false);
    const [showPopup, setShowPopup] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [isLoading, setIsLoading] = useState(false)

    const [users, setUsers] = useState([]);
    const [activeUser, setActiveUser] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [postsPerPage, setPostperPage] = useState(10);
    const [showNotif, setShowNotif] = useState(false);
    const [activeMenu, setActiveMenu] = useState("");
    const [showsubMenu, setShowsubMenu] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const isFetching = useRef(false);
    const indexOfLastUser = currentPage * postsPerPage;
    const indexOfFirstUser = indexOfLastUser - postsPerPage;
    const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);

    const totalPages = Math.ceil(users.length / postsPerPage);
    const Paginate = (page) => setCurrentPage(page);


    const rawVal = localStorage.getItem('loginVal');
    let loginVal = rawVal ? JSON.parse(rawVal) : null;
    let token = loginVal ? loginVal.token : null;


    const savedImage = localStorage.getItem("image")

    function clickEditprofile() {
        navigation('/Editprofile')
    }
    function clickUpgradeplans() {
        navigation('/Upgrade')
    }
    function clickLogin() {
        localStorage.clear();
        localStorage.removeItem('loginVal');
        localStorage.removeItem('token');
        logoutAPICall();
        navigation('/login')
    }
    function clicktoViewpage() {
        navigation('/Viewpage')
    }

    function clickSearchPage() {
        navigation('/Searchpage')
    }

    function clickSettingspage() {
        navigation('/settingspage')
    }
    function showToast(message) {
        toast.success(message, {
            position: "top-right",
            autoClose: 2000
        });
    }
    function showToastFailed(message) {
        toast.error(message, {
            position: "top-right",
            autoClose: 2000
        });
    }
    useEffect(() => {
        if (loginVal == null) {
            navigation('/login'); return;
        }
        if (calledOnce.current) return; // already called
        calledOnce.current = true;
        setActiveMenu("sent_all");
        getInterestAPICall(loginVal.user_Id, 3);
    }, []);

    function saveShortListAPICall(userId, index, type) {
        setIsLoading(true);
        axios.get(
            ApiConfig.getUrl("User/shortList"),
            {
                params: {
                    userId: loginVal.user_Id, viewedListId: 0, opponentId: userId, type: type
                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )

            .then(response => {
                const api = ApiResponse.fromJson(response.data);
                console.log("Response:", api.statusCode);

                if (api.statusCode == 200) {
                    setIsLoading(false);

                    setUsers(prevUsers => {
                        const updatedUsers = [...prevUsers];
                        updatedUsers[index] = {
                            ...updatedUsers[index],
                            is_Shortlist: !updatedUsers[index].is_Shortlist,
                        };
                        return updatedUsers;
                    });

                    if (type === 0) {
                        showToast("Shortlisted Successfully!");
                    } else if (type === 1) {
                        showToast("Removed from Shortlist Successfully!");
                    }

                } else {
                    setIsLoading(false);
                    showToastFailed(api.errorMessage);
                }

            })
            .catch(error => {
                setIsLoading(false);
                setUsers([]);
                showToastFailed("ShortList failed!");
                //   showToastFailed(error);
                console.error("Error:", error);
            });
    }

    function sendInterestAPICall(userId, opponentId, index, type) {
        setIsLoading(true);
        axios.get(
            ApiConfig.getUrl("User/sendPartnerRequest"),
            {
                params: {
                    userId: userId, viewedListId: 0, opponentId: opponentId, type: type
                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )

            .then(response => {
                const api = ApiResponse.fromJson(response.data);
                console.log("Response:", api.statusCode);
                if (api.statusCode == 200 && api.status === true) {

                    setIsLoading(false);

                    if (type == 0) {
                        setUsers(prev =>
                            prev.map((user, i) =>
                                i === index ? { ...user, is_Interestlist: true } : user
                            )
                        );
                    } else if (type == -1) {
                        setUsers(prev =>
                            prev.map((user, i) =>
                                i === index
                                    ? { ...user, is_Interestlist: false, type: -1 }
                                    : user
                            )
                        );
                    }

                    setUsers(prev =>
                        prev.map((user, i) =>
                            i === index ? { ...user, type: type } : user
                        )
                    );

                    if (type === 0) {
                        showToast("Interest Sent Successfully!");
                    } else if (type === -1) {
                        showToast("Interest Removed Successfully!");
                    } else if (type === 1) {
                        showToast("Interest Accepted Successfully!");
                    } else if (type === 2) {
                        showToast("Interest Declined Successfully!");
                    }
                }
            })
            .catch(error => {
                setIsLoading(false);
                showToastFailed("Interest Sent fail!");
            });
    }

    function getInterestAPICall(userId, type, pageNumber = 1) {
        if (!loginVal || isFetching.current || (pageNumber > 1 && !hasMore)) return;

        isFetching.current = true;

        setIsLoading(true);
        console.log("Response:", "response.data");
        axios.get(
            ApiConfig.getUrl("User/InterestListRequest"),
            {
                params: {
                    userId: userId, type: type, pageNum: pageNumber,
                    pageSize: postsPerPage
                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )
            .then(response => {
                console.log("Response:", response.data);
                const api = ApiResponse.fromJson(response.data);
                console.log("Response:", api.statusCode);

                if (api.status && api.statusCode == 200) {

                    setIsLoading(false);
                    const interestList = api.response?.map(item => ProfileListData.fromJson(item)) || [];
                    console.log("Page ".concat(pageNumber, " loaded. Items:"), interestList.length);
                    console.log("Response:", api.interestList);
                    setUsers(interestList);
                    //         setHasMore(userList.length > 0 && userList.length >= postsPerPage);
                    //         setCurrentPage(pageNumber);
                    //         // showToast(api.errorMessage);
                    //     } else {
                    //         showToast(api.errorMessage);
                    //         setIsLoading(false);
                    //         setUsers([]);
                    //     }
                    // })
                    setHasMore(interestList.length > 0 && interestList.length >= postsPerPage);
                    setCurrentPage(pageNumber);
                } else {
                    // Only clear users if the very first page failed to load
                    if (pageNumber === 1) setUsers([]);
                    showToast(api.errorMessage);
                }
                isFetching.current = false;
                setIsLoading(false);
            })
            .catch(error => {
                isFetching.current = false;
                setIsLoading(false);
                setUsers([]);
                showToastFailed(error);
                console.error("Error:", error);
            });
    }


    function handlePageChange(page) {

        if (page < 1) return;

        let type = 3;

        switch (activeMenu) {

            case "sent_all":
                type = 3;
                break;

            case "sent_pending":
                type = 0;
                break;

            case "sent_accepted":
                type = 1;
                break;

            case "sent_declined":
                type = 2;
                break;

            case "received_all":
                type = 7;
                break;

            case "received_pending":
                type = 4;
                break;

            case "received_accepted":
                type = 5;
                break;

            case "received_declined":
                type = 6;
                break;

            default:
                type = 3;
        }

        getInterestAPICall(
            loginVal.user_Id,
            type,
            page
        );

        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    function sendChatRequestAPIcall(userId, opponentId, index, requestType) {
        setIsLoading(true);
        axios.get(
            ApiConfig.getUrl("User/sendChatRequest"),
            {
                params: {
                    user_Id: userId, opponent_Id: opponentId, requestType: requestType, LoggedInUser_Id: userId
                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )

            .then(response => {
                const api = ApiResponse.fromJson(response.data);
                console.log("Response:", api.statusCode);
                if (api.statusCode == 200) {

                    setIsLoading(false);
                    if (requestType == 0) {
                        setUsers(prev =>
                            prev.map((user, i) =>
                                i === index ? { ...user, is_ChatRequest: true } : user
                            )
                        );
                    }
                    setUsers(prev =>
                        prev.map((user, i) =>
                            i === index ? { ...user, requestType: requestType } : user
                        )
                    );

                    showToast("Chat Request Sent Successfully!");

                } else {
                    showToastFailed(api.errorMessage);

                    setIsLoading(false);
                }

            })
            .catch(error => {
                setIsLoading(false);
                showToastFailed("Chat Request Sent fail!");
            });
    }

    function logoutAPICall() {

        setIsLoading(true);

        axios.post(
            ApiConfig.getUrl("User/logout"),
            {
                user_Id: loginVal.user_Id
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )
            .then((response) => {

                const api = ApiResponse.fromJson(response.data);

                setIsLoading(false);

                if (api.status && api.statusCode === 200) {

                    showToast("Logout successful.");


                    setTimeout(() => {
                        localStorage.clear();
                        navigation("/login", { replace: true });
                    }, 1000);

                } else {
                    showToastFailed(api.errorMessage || "Logout failed");
                }

            })
            .catch((error) => {

                setIsLoading(false);

                if (error.response?.status === 401) {
                    localStorage.clear();
                    navigation("/login", { replace: true });
                    return;
                }

                console.error(error);
                showToastFailed("Logout failed");
            });
    }








    const navigation = useNavigate()
    function clicktoCustomerdetailsscreen(userId) {
        navigation('/Customerdetails', { state: { userId: userId } })
    }

    function clickHomeListPage() {
        navigation('/HomeList')
    }


    const disableRightClick = (e) => {
        if (ApiConfig.ENV == "PRD") {
            e.preventDefault();
        }
    };
    return (
        <>
            <div onContextMenu={disableRightClick}>
                <ToastContainer />
                <div className='fullview'>
                    {isLoading && (
                        <div className="loader-overlay">
                            <Oval
                                height={60}
                                width={60}
                                color="orange"
                                secondaryColor="#cccccc"
                                strokeWidth={4}
                                visible={true}
                            />
                        </div>
                    )}


                    <div className="top-bar">
                        <div className='container'>
                            <ul>
                                <img src={logo} alt='logo' style={{ width: '70px' }} />
                                {/*<li>Matches</li> */}
                                <li onClick={clicktoViewpage} className="m-2 p-1">
                                    <i className="bi bi-people d-inline m-2"></i>

                                    <span className="d-none d-sm-inline text-decoration-none text-dark">All Matches</span>
                                </li>
                                <li className="m-2 p-1" onClick={clickHomeListPage}>
                                    <i className="bi bi-house d-inline m-2"></i>
                                    <span className="d-none d-sm-inline text-decoration-none text-dark">Home</span>
                                </li>
                                <li onClick={clickSearchPage} className='m-2 p-1'><i class="bi bi-search d-inline m-2"></i>
                                    <span className="d-none d-sm-inline text-decoration-none text-dark">Search</span></li>
                                <li onClick={() => setShowNotif(true)} className="m-2 p-1">
                                    <i className="bi bi-bell d-inline m-2"></i>
                                    <span className="d-none d-sm-inline  text-decoration-none text-dark">Notification</span>
                                </li>
                                <Notification
                                    show={showNotif}
                                    onClose={() => setShowNotif(false)}
                                />
                                {/* <button className='top-button'>Switch account</button> */}
                                <div style={{ position: "relative", display: "inline-block" }}>
                                    <img style={{ width: "50px", height: "50px", borderRadius: "50% " }}

                                        src={savedImage || default_avatar}
                                        onClick={() => setShowMenu(!showMenu)}
                                    />
                                    {showMenu && (
                                        <div className="dropdown-menu show" style={{ position: "absolute", right: "5px" }}>
                                            <div className="dropdown-item" style={{ cursor: "pointer" }} onClick={clickEditprofile}>Edit Profile</div>
                                            {/* <div className="dropdown-item" style={{ cursor: "pointer" }} onClick={clickUpgradeplans}>Upgrade Plan</div> */}
                                            <div className="dropdown-item " style={{ cursor: "pointer" }} onClick={clickSettingspage} >Settings</div>
                                            {/* {showsubMenu && (
                                 <div className="dropdown-item" style={{ cursor: "pointer", textAlign: "center",backgroundColor:"darkorange",color:"white"}}>Block List</div>
                                 )} */}
                                            <div className="dropdown-item" style={{ cursor: "pointer" }} onClick={clickLogin}>Logout</div>
                                        </div>
                                    )}
                                </div>
                                {/* <button className='top-button'>Settings</button> */}
                            </ul>
                        </div>

                    </div>

                    <div className='container-md' onClick={() => setShowMenu(false)} >
                        <div className='row mt-5 pt-5 align-items-center= gl-0 gx-0'>
                            <div className="d-lg-none p-2 text-end align-items-end" >
                                <button
                                    className="btn btn-outline-secondary"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#interestMenu"
                                >
                                    ☰
                                </button>
                            </div>

                            <div id="interestMenu" className='collapse d-lg-block col-lg-3 p-2 col-sm-12 border-solid-w-20 border_menu sticky-sidebar'>

                                <b>Interests Received</b>
                                <div className='interest-topic' >
                                    <label className={`topic_menu ${activeMenu === "received_all" ? "active-menu" : ""}`}
                                        onClick={() => {
                                            setActiveMenu("received_all");
                                            setCurrentPage(1);
                                            getInterestAPICall(loginVal.user_Id, 7, 1);
                                        }}>All</label>
                                    <label className={`topic_menu ${activeMenu === "received_pending" ? "active-menu" : ""}`}
                                        onClick={() => {
                                            setActiveMenu("received_pending");
                                            setCurrentPage(1);
                                            getInterestAPICall(loginVal.user_Id, 4, 1);
                                        }
                                        }>Pending</label>
                                    <label className={`topic_menu ${activeMenu === "received_accepted" ? "active-menu" : ""}`}
                                        onClick={() => {
                                            setActiveMenu("received_accepted");
                                            setCurrentPage(1);
                                            getInterestAPICall(loginVal.user_Id, 5, 1);
                                        }

                                        }>Accepted/Replied</label>
                                    <label className={`topic_menu ${activeMenu === "received_declined" ? "active-menu" : ""}`}
                                        onClick={() => {
                                            setActiveMenu("received_declined");
                                            setCurrentPage(1);
                                            getInterestAPICall(loginVal.user_Id, 6, 1);
                                        }

                                        }>Declined</label>


                                </div>
                                <hr />
                                <b>Interests Sent</b>
                                <div className='interest-topic' >
                                    <label className={`topic_menu ${activeMenu === "sent_all" ? "active-menu" : ""}`}
                                        onClick={() => {
                                            setActiveMenu("sent_all");
                                            setCurrentPage(1);
                                            getInterestAPICall(loginVal.user_Id, 3, 1);
                                        }
                                        }>All</label>
                                    <label className={`topic_menu ${activeMenu === "sent_pending" ? "active-menu" : ""}`}
                                        onClick={() => {
                                            setActiveMenu("sent_pending");
                                            setCurrentPage(1);
                                            getInterestAPICall(loginVal.user_Id, 0, 1);
                                        }
                                        }>Pending</label>
                                    <label className={`topic_menu ${activeMenu === "sent_accepted" ? "active-menu" : ""}`}
                                        onClick={() => {
                                            setActiveMenu("sent_accepted");
                                            setCurrentPage(1);
                                            getInterestAPICall(loginVal.user_Id, 1, 1);
                                        }
                                        }>Accepted/Replied</label>
                                    <label className={`topic_menu ${activeMenu === "sent_declined" ? "active-menu" : ""}`}
                                        onClick={() => {
                                            setActiveMenu("sent_declined");
                                            setCurrentPage(1);
                                            getInterestAPICall(loginVal.user_Id, 2, 1);
                                        }
                                        }>Declined</label>

                                </div>


                            </div>
                            <div className='col-lg-9 col-sm-12'>
                                {/* <label id="interestMenu" className='h5 collapse'>
                                    Accordingly
                                </label> */}
                                <label className='collapse' id="interestMenu">Interests and responses from free members</label>
                                <div className='ms-lg-2'>

                                    {
                                        users.map((item, index) => (
                                            <div key={item.userId} className='client ' onClick={() => clicktoCustomerdetailsscreen(item.userId)}
                                                style={{
                                                    background: item.themeColour || localStorage.getItem("themeColor",)
                                                }}>
                                                <div style={{ position: "relative" }}>

                                                    {(item.isPaid === true || item.is_Paid === true) && (
                                                        <div
                                                            style={{
                                                                position: "absolute",
                                                                top: "8px",
                                                                right: "8px",
                                                                zIndex: 10,
                                                                background: "#FFD700",
                                                                color: "#000",
                                                                padding: "4px 8px",
                                                                borderRadius: "15px",
                                                                fontSize: "11px",
                                                                fontWeight: "bold",
                                                                boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                                                            }}
                                                        >
                                                            ⭐ {item.lookUpId || "Premium"}
                                                        </div>
                                                    )}

                                                    <img
                                                        className="list-a-img"
                                                        src={
                                                            item.profilePath == null || item.profilePath === ""
                                                                ? default_avatar
                                                                : item.profilePath
                                                        }
                                                        style={{
                                                            height: "80%",
                                                            objectFit: "fill",
                                                            objectPosition: "center",
                                                            filter: item.isBlurred ? "blur(5px)" : "none",
                                                            transition: "filter 0.3s ease"
                                                        }}
                                                        alt="Profile"
                                                    />

                                                </div>
                                                <div className='col details' >
                                                    <div >
                                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                            <label className='name fw-bold' style={{
                                                                background: item.themeColourText || "#131111",
                                                                WebkitBackgroundClip: "text",
                                                                WebkitTextFillColor: "transparent",
                                                                backgroundClip: "text"
                                                            }}>{item.name}</label>

                                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>

                                                                {/* <div>
                                                                    <button
                                                                        className="send-button bg-primary"
                                                                        onClick={(e) =>
                                                                            sendChatRequestAPIcall(loginVal.user_Id, item.userId, index, 0)}
                                                                    >
                                                                        {item.is_ChatRequest == true ? "Sent Chat Request" : "Send Chat Request"}                                                                    
                                                                
                                                                    </button>
                                                                </div> */}

                                                                <div
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        saveShortListAPICall(item.userId, index, item.is_Shortlist == true ? 1 : 0);
                                                                    }}>


                                                                    <img className='shortlist-logo' src={item.is_Shortlist == true ? shortlist : notShortlist} alt='logo' /></div>
                                                            </div>
                                                        </div>
                                                        <div style={{ paddingBottom: '10px' }} ><label className='normal-text-grey'
                                                            style={{
                                                                background: item.themeColourNumber || "#333333",
                                                                WebkitBackgroundClip: "text",
                                                                WebkitTextFillColor: "transparent",
                                                                backgroundClip: "text",
                                                                fontWeight: "bold"
                                                            }}> IMIT{item.userNum}</label></div>

                                                        <ul style={{
                                                            display: "flex",
                                                            flexWrap: "wrap",
                                                            listStyleType: "disc",
                                                            paddingLeft: "0px",
                                                            margin: "0", textDecoration: "none",
                                                            listStyleType: "none", color: item.themeColourText
                                                        }}>

                                                            <li style={{
                                                                paddingTop: 0, paddingBottom: 0, paddingRight: 10, paddingLeft: 0,
                                                                listStyleType: 'none',
                                                                textDecoration: 'none',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                background: item.themeColourText || "#333333",
                                                                WebkitBackgroundClip: "text",
                                                                WebkitTextFillColor: "transparent",
                                                                backgroundClip: "text"
                                                            }} className='normal-text'>
                                                                <span style={{
                                                                    paddingRight: 10,
                                                                    fontSize: '1.2rem',
                                                                    marginBottom: '4px',
                                                                    textDecoration: 'none',
                                                                    color: 'rgb(255, 123, 0)',
                                                                    WebkitTextFillColor: 'rgb(255, 123, 0)'
                                                                }}>•</span>{item.age} yrs
                                                            </li>

                                                            <li style={{
                                                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10, background: item.themeColourText || "#333333",
                                                                WebkitBackgroundClip: "text",
                                                                WebkitTextFillColor: "transparent",
                                                                backgroundClip: "text"
                                                            }} className='normal-text'>
                                                                <span style={{
                                                                    paddingRight: 10,
                                                                    fontSize: '1.2rem',
                                                                    marginBottom: '4px',
                                                                    textDecoration: 'none',
                                                                    color: 'rgb(255, 123, 0)',
                                                                    WebkitTextFillColor: 'rgb(255, 123, 0)'
                                                                }}>•</span> {item.height} CM
                                                            </li>
                                                            <li style={{
                                                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10, background: item.themeColourText || "#333333",
                                                                WebkitBackgroundClip: "text",
                                                                WebkitTextFillColor: "transparent",
                                                                backgroundClip: "text"
                                                            }} className='normal-text'>
                                                                <span style={{
                                                                    paddingRight: 10,
                                                                    fontSize: '1.2rem',
                                                                    marginBottom: '4px',
                                                                    textDecoration: 'none',
                                                                    color: 'rgb(255, 123, 0)',
                                                                    WebkitTextFillColor: 'rgb(255, 123, 0)'
                                                                }}>•</span> {item.caste}
                                                            </li>


                                                        </ul>

                                                        <ul style={{
                                                            display: "flex",
                                                            flexWrap: "wrap",
                                                            listStyleType: "disc",
                                                            paddingLeft: "0px",
                                                            margin: "0",
                                                        }}>


                                                            <li style={{
                                                                paddingTop: 0, paddingBottom: 0, paddingRight: 10, paddingLeft: 0, background: item.themeColourText || "#333333",
                                                                WebkitBackgroundClip: "text",
                                                                WebkitTextFillColor: "transparent",
                                                                backgroundClip: "text"
                                                            }} className='normal-text'>
                                                                <span style={{
                                                                    paddingRight: 10,
                                                                    fontSize: '1.2rem',
                                                                    marginBottom: '4px',
                                                                    textDecoration: 'none',
                                                                    color: 'rgb(255, 123, 0)',
                                                                    WebkitTextFillColor: 'rgb(255, 123, 0)'
                                                                }}>•</span> {item.religion}
                                                            </li>
                                                            <li style={{
                                                                paddingTop: 0, paddingBottom: 0, paddingRight: 10, paddingLeft: 0, background: item.themeColourText || "#333333",
                                                                WebkitBackgroundClip: "text",
                                                                WebkitTextFillColor: "transparent",
                                                                backgroundClip: "text"
                                                            }} className='normal-text'>
                                                                <span style={{
                                                                    paddingRight: 10,
                                                                    fontSize: '1.2rem',
                                                                    marginBottom: '4px',
                                                                    textDecoration: 'none',
                                                                    color: 'rgb(255, 123, 0)',
                                                                    WebkitTextFillColor: 'rgb(255, 123, 0)'
                                                                }}>•</span> {item.qualification}
                                                            </li>

                                                            <li style={{
                                                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10, background: item.themeColourText || "#333333",
                                                                WebkitBackgroundClip: "text",
                                                                WebkitTextFillColor: "transparent",
                                                                backgroundClip: "text"
                                                            }} className='normal-text'>
                                                                <span style={{
                                                                    paddingRight: 10,
                                                                    fontSize: '1.2rem',
                                                                    marginBottom: '4px',
                                                                    textDecoration: 'none',
                                                                    color: 'rgb(255, 123, 0)',
                                                                    WebkitTextFillColor: 'rgb(255, 123, 0)'
                                                                }}>•</span> {item.occupation}
                                                            </li>

                                                        </ul>

                                                        <ul style={{
                                                            display: "flex",
                                                            flexWrap: "wrap",
                                                            listStyleType: "disc",
                                                            paddingLeft: "0px",
                                                            listStylePosition: "inside",
                                                            margin: "0",
                                                        }}>


                                                            <li style={{
                                                                paddingTop: 0, paddingBottom: 0, paddingRight: 10, paddingLeft: 0, background: item.themeColourText || "#333333",
                                                                WebkitBackgroundClip: "text",
                                                                WebkitTextFillColor: "transparent",
                                                                backgroundClip: "text"
                                                            }} className='normal-text'>
                                                                <span style={{
                                                                    paddingRight: 10,
                                                                    fontSize: '1.2rem',
                                                                    marginBottom: '4px',
                                                                    textDecoration: 'none',
                                                                    color: 'rgb(255, 123, 0)',
                                                                    WebkitTextFillColor: 'rgb(255, 123, 0)'
                                                                }}>•</span> {item.city}
                                                            </li>

                                                            <li style={{
                                                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10, background: item.themeColourText || "#333333",
                                                                WebkitBackgroundClip: "text",
                                                                WebkitTextFillColor: "transparent",
                                                                backgroundClip: "text"
                                                            }} className='normal-text'>
                                                                <span style={{
                                                                    paddingRight: 10,
                                                                    fontSize: '1.2rem',
                                                                    marginBottom: '4px',
                                                                    textDecoration: 'none',
                                                                    color: 'rgb(255, 123, 0)',
                                                                    WebkitTextFillColor: 'rgb(255, 123, 0)'
                                                                }}>•</span> {item.state}
                                                            </li>
                                                            <li style={{
                                                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10, background: item.themeColourText || "#333333",
                                                                WebkitBackgroundClip: "text",
                                                                WebkitTextFillColor: "transparent",
                                                                backgroundClip: "text"
                                                            }} className='normal-text'>
                                                                <span style={{
                                                                    paddingRight: 10,
                                                                    fontSize: '1.2rem',
                                                                    marginBottom: '4px',
                                                                    textDecoration: 'none',
                                                                    color: 'rgb(255, 123, 0)',
                                                                    WebkitTextFillColor: 'rgb(255, 123, 0)'
                                                                }}>•</span> {item.country}.
                                                            </li>
                                                        </ul>

                                                        {/* <div><label className='normal-text'>IMIT{item.userId} | {item.age} yrs, {item.height}</label></div>
                                                        <div><label className='normal-text'>{item.caste}, {item.religion} </label></div>
                                                        <div><label className='normal-text'>{item.qualification},{item.occupation}</label></div>
                                                        <div><label className='normal-text'>{item.city}, {item.state}.</label></div>
                                                        <div><label className='normal-text'>{item.country}.</label></div> */}

                                                    </div>
                                                    <div className=' mt-3'>

                                                        {item.type == 0 && item.is_Interestlist == true && (
                                                            <button
                                                                className='send-button'
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    sendInterestAPICall(loginVal.user_Id, item.userId, index, -1);
                                                                }}
                                                            >
                                                                Remove Interest
                                                            </button>
                                                        )}
                                                        {item.type == 1 && item.is_Interestlist == true && (
                                                            <label style={{ color: "green" }}>
                                                                <b>Your request is accepted</b>
                                                            </label>
                                                        )}

                                                        {item.type == 2 && item.is_Interestlist == true && (
                                                            <label style={{ color: "red" }}>
                                                                <b>Your request is declined</b>
                                                            </label>
                                                        )}


                                                        {(item.type == null || item.type == -1) && (
                                                            <button
                                                                className='send-button'
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    sendInterestAPICall(loginVal.user_Id, item.userId, index, 0);
                                                                }}
                                                            >
                                                                Send Interest
                                                            </button>
                                                        )}


                                                        {item.type == 0 && item.is_Interestlist == false && (

                                                            <>
                                                                <button
                                                                    className='send-button'
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        sendInterestAPICall(item.userId, loginVal.user_Id, index, 1);
                                                                    }}
                                                                >
                                                                    Accept Interest
                                                                </button>

                                                                <button
                                                                    className='send-button'
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        sendInterestAPICall(item.userId, loginVal.user_Id, index, 2);
                                                                    }}
                                                                >
                                                                    Decline
                                                                </button>

                                                            </>
                                                        )}

                                                        {item.type == 1 && item.is_Interestlist == false && (

                                                            <>
                                                                <label>
                                                                    Accepted  </label>

                                                                <button
                                                                    className='send-button'
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        sendInterestAPICall(item.userId, loginVal.user_Id, index, 2);
                                                                    }}
                                                                >
                                                                    Decline
                                                                </button>

                                                            </>
                                                        )}

                                                        {item.type == 2 && item.is_Interestlist == false && (

                                                            <>

                                                                <button
                                                                    className='send-button'
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        sendInterestAPICall(item.userId, loginVal.user_Id, index, 1);
                                                                    }}
                                                                >
                                                                    Accept Interest
                                                                </button>
                                                                <label>
                                                                    Declined
                                                                </label>


                                                            </>
                                                        )}

                                                    </div>

                                                    <div className="me-3 mt-2">

                                                        {(item.type == 1) && (item.requestType == 0) && (item.is_ChatRequest == true) && (
                                                            <button
                                                                className='send-button' style={{ fontSize: "12px" }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    sendChatRequestAPIcall(loginVal.user_Id, item.userId, index, -1);
                                                                }}>
                                                                Remove Chat Interest
                                                            </button>
                                                        )}


                                                        {(item.type == 1) && (item.requestType == null || item.requestType == -1) && (
                                                            <button
                                                                className='send-button' style={{ fontSize: "12px" }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    sendChatRequestAPIcall(loginVal.user_Id, item.userId, index, 0);
                                                                }}
                                                            >
                                                                Send Chat Interest
                                                            </button>
                                                        )}


                                                        {(item.type == 1) && (item.requestType == 0) && (item.is_ChatRequest == false) && (

                                                            <>
                                                                <button
                                                                    className='send-button'
                                                                    style={{ fontSize: "13px" }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        sendChatRequestAPIcall(item.userId, loginVal.user_Id, index, 1);
                                                                    }}
                                                                >
                                                                    Accept Chat Interest
                                                                </button>

                                                                <button
                                                                    className='send-button '
                                                                    style={{ fontSize: "13px" }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        sendChatRequestAPIcall(item.userId, loginVal.user_Id, index, 2);
                                                                    }}
                                                                >
                                                                    Decline Chat Interest
                                                                </button>

                                                            </>
                                                        )}


                                                        {(item.requestType == 1) && (
                                                            <div
                                                                title="Chat"
                                                                className='ChatMessage'
                                                                // style={{ cursor: loginVal?.isPaid ? 'pointer' : 'not-allowed' }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    navigation('/ChatInitiate', { state: { opponentId: item.userId, opponentName: item.name } })
                                                                }}
                                                            >
                                                                <i className="bi bi-chat-dots fs-3" style={{ color: "darkorange" }}></i>
                                                            </div>
                                                        )}


                                                    </div>
                                                    <br />

                                                    <div className='row align-items-between'>
                                                        <div className="col d-flex flex-column flex-md-row justify-content-between gap-2">
                                                            {/* <label className='verify-text normal-text me-2'>

                                                                <span
                                                                    style={{
                                                                        cursor: "none",
                                                                        textDecoration: "none",
                                                                        color:
                                                                            item.email_Status == true ? "green" : "red"

                                                                    }}>


                                                                    {
                                                                        item.email_Status == true ? "Email verified" : "Email Not Verified"}
                                                                </span>
                                                            </label> */}
                                                            <label
                                                                className="verify-text normal-text p-1 mt-0"
                                                                style={{
                                                                    backgroundColor: "hsl(90, 42%, 87%)",
                                                                    borderRadius: "6px",
                                                                    width: "150px",
                                                                    height: "30px"
                                                                }}
                                                            >
                                                                <i className="bi bi-phone ps-1 pe-1" style={{ color: "green" }}></i>
                                                                <span
                                                                    style={{
                                                                        paddingRight: "5px",
                                                                        fontSize: "13px",
                                                                        textDecoration: "none",
                                                                        fontWeight: "bold",
                                                                        color: item.mobileNumber_Status ? "green" : "red"
                                                                    }}
                                                                >
                                                                    {item.mobileNumber_Status
                                                                        ? "Mobile Verified"
                                                                        : "Mobile Not Verified"}
                                                                </span>
                                                            </label>
                                                            {item.documentStatus === 0 && (
                                                                <label
                                                                    className="verify-text normal-text p-1"
                                                                    style={{
                                                                        backgroundColor: "hsl(90, 42%, 87%)",
                                                                        borderRadius: "6px",
                                                                        height: "30px"
                                                                    }}
                                                                >
                                                                    <i
                                                                        className="bi bi-file-earmark-check ps-1 pe-1"
                                                                        style={{ color: "green" }}
                                                                    ></i>
                                                                    <span
                                                                        style={{
                                                                            fontSize: "13px",
                                                                            fontWeight: "bold",
                                                                            textDecoration: "none",
                                                                            color: "green",

                                                                        }}
                                                                    >
                                                                        Documents Verified
                                                                    </span>
                                                                </label>
                                                            )}
                                                        </div>
                                                    </div>


                                                    {/* <p>She {item.isSendInterest === 5} your Request. </p> */}

                                                </div>

                                            </div>
                                        ))}

                                    {users.length > 0 && (
                                        <div className="pagination-modern">

                                            <button
                                                className="page-btn"
                                                onClick={() => handlePageChange(1)}
                                                disabled={currentPage === 1}
                                            >
                                                ⏮ First
                                            </button>

                                            <button
                                                className="page-btn"
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                disabled={currentPage === 1}
                                            >
                                                ◀ Prev
                                            </button>

                                            <div className="page-indicator">
                                                Page <span>{currentPage}</span>
                                            </div>

                                            <button
                                                className="page-btn"
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                disabled={!hasMore}
                                            >
                                                Next ▶
                                            </button>

                                        </div>
                                    )}

                                </div>

                            </div>

                        </div>
                    </div >

                </div>
            </div >

            <footer className='bg-dark text-white text-center'>
                <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
            </footer>
        </>
    );
}

export default Interestpage;
